module.exports = __webpack_public_path__ + "img/grade.8c8de35f.png";